/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const LogoutIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    {...props}
    data-palette="LogoutIcon">
    <g fill="none">
      <path d="M0 0h22v22H0z" />
      <path
        fill="currentColor"
        d="M4.583 20.167a.916.916 0 0 1-.916-.917V2.75c0-.506.41-.917.916-.917h12.834c.506 0 .916.41.916.917V5.5H16.5V3.667h-11v14.666h11V16.5h1.833v2.75c0 .506-.41.917-.916.917H4.583zm11.917-5.5v-2.75h-6.417v-1.834H16.5v-2.75L21.083 11 16.5 14.667z"
      />
    </g>
  </svg>
);

export default LogoutIcon;
